import { gql } from 'urql';

export const REPORTE_MAYOR = gql`
  query Mayor($cuentaId: ID!, $desde: String!, $hasta: String!, $centroId: ID) {
    mayor(cuentaId: $cuentaId, desde: $desde, hasta: $hasta, centroId: $centroId) {
      cuentaCodigo
      cuentaNombre
      saldoInicial
      saldoFinal
      movimientos {
        fecha
        asientoId
        asientoNumero
        glosa
        descripcion
        debe
        haber
        saldo
      }
    }
  }
`;

export const REPORTE_SUMAS_SALDOS = gql`
  query SumasSaldos($empresaId: ID!, $periodo: String!) {
    sumasSaldos(empresaId: $empresaId, periodo: $periodo) {
      cuentaId
      cuentaCodigo
      cuentaNombre
      tipo
      debe
      haber
      saldo
    }
  }
`;

export const REPORTE_BALANCE = gql`
  query BalanceComprobacion($empresaId: ID!, $periodo: String!) {
    balanceComprobacion(empresaId: $empresaId, periodo: $periodo) {
      tipo
      codigo
      nombre
      saldoDebe
      saldoHaber
    }
  }
`;

